import { useQuery } from '@apollo/client';
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { DecisionDefinitionListQuery } from '@css-xp/apd-common';
import { ErrorComponents } from '@css-xp/base';
//@ts-ignore
import AppsSplash from '@css-xp/base/assets/img/apps-splash.png';
import { useApplicationContext } from '@css-xp/base/common-context';
import { decisionDefinitionList } from '../queries/decisions';
import DecisionSelect, { DecisionSelectOption } from './decision-table/decision-select';
import DecisionTable from './decision-table/decision-table';
import RuleHistory from './rule-history/rule-history';
import './rule-manager.scss';

const RuleManager = () => {
  const ruleHistoryRef = useRef<any>();
  const user = useApplicationContext();
  const userId = user?.userId.split('@')[0];
  const [decisionDefinition, setDecisionDefinition] = useState<DecisionSelectOption | undefined>();
  const {
    data: decisionListData,
    loading: decisionListLoading,
    error: decisionListError,
  } = useQuery<DecisionDefinitionListQuery>(decisionDefinitionList, {
    skip: !user,
    variables: {
      id: userId,
    },
  });

  const decisionListOptions: DecisionSelectOption[] = useMemo(() => {
    return (decisionListData?.decisionDefinitionList
      ?.map((d) =>
        d
          ? {
              label: d?.decisionDefinition?.name,
              value: d?.decisionDefinition?.key,
              id: d?.decisionDefinition?.id,
              ssamContainer: d?.ssamContainer,
            }
          : null
      )
      .filter((d) => !!d) ?? []) as DecisionSelectOption[];
  }, [decisionListData?.decisionDefinitionList]);

  const reloadRuleHistory = useCallback(() => {
    ruleHistoryRef?.current?.reloadRuleHistory();
  }, []);

  if (decisionListError) return <ErrorComponents.GenericErrorPage error={decisionListError} />;

  return (
    <div className={decisionDefinition ? 'rule-manager ' : 'rule-manager-landing-page'}>
      {!decisionDefinition ? (
        <>
          <div>
            <img src={AppsSplash} className="rule-manager-landing-icon" />
          </div>
          <div>
            <h1 className="rule-manager-icon-heading">Welcome to Rule Manager</h1>
          </div>
        </>
      ) : (
        <div className="rule-manager-page-heading">
          <h1>Rule Manager</h1>
        </div>
      )}
      <div className="decision-table-selection" data-testid="decision-selection-dropdown">
        <DecisionSelect options={decisionListOptions} onChange={setDecisionDefinition} disabled={decisionListLoading} />
      </div>
      {decisionDefinition && (
        <>
          <DecisionTable
            decisionDefinitionKey={decisionDefinition?.value}
            reloadRuleHistory={reloadRuleHistory}
            ssamContainer={decisionDefinition?.ssamContainer}
          />
          <RuleHistory decisionDefinitionKey={decisionDefinition?.value} ref={ruleHistoryRef} />
        </>
      )}
    </div>
  );
};

export default RuleManager;
